import { render, staticRenderFns } from "./OrdersOverview.vue?vue&type=template&id=7cb1ba5b&scoped=true"
import script from "./OrdersOverview.vue?vue&type=script&lang=js"
export * from "./OrdersOverview.vue?vue&type=script&lang=js"
import style0 from "./OrdersOverview.vue?vue&type=style&index=0&id=7cb1ba5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb1ba5b",
  null
  
)

export default component.exports